var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.cards),function(card,index){return _c('v-col',{key:index},[_c('MoneyCard',{attrs:{"title":card.status_la || card.title || card.display_type_la,"total":card.total,"billing_count":card.count_billing,"bg_color":card.bg_color,"route":card.route,"icon":card.icon,"icon_color":card.icon_color,"unit_count":card.unit_count}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }